import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import App from './App.vue'
import router from './router'
import axioss from 'axios'
import store from './store'
import vuetify from './plugins/vuetify';
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask)
Vue.use(VueClipboard)

Vue.prototype.$http = axioss

const token = localStorage.getItem('token_manager')
if (token) {
  axioss.defaults.headers.common['Authorization'] = `Bearer ${token}`
} 

axioss.interceptors.request.use(function (config) {
  store.commit('loader', true)
  return config;
}, function (error) { 
  return Promise.reject(error);
});

axioss.interceptors.response.use(function (response) {
  store.commit('loader', false)
  return response;
}, function (error) { 
  store.commit('loader', false)
  return Promise.reject(error);
});

Vue.config.productionTip = false

// eslint-disable-next-line no-unused-vars
const app = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
